import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DevUILoader } from "../lib/devtools/loader.js";
import { BrowserRouter } from "../lib/routing/components/BrowserRouter.js";
import { APIProvider } from "../utils/APIProvider.js";
export function SPARoot() {
    return (_jsxs(APIProvider, { children: [_jsx(BrowserRouter, {}), _jsx(DevUILoader, {})] }));
}
